import React, { useRef } from "react";
import styles from "./AutoGrowingTextArea.module.scss";
import { combineClasses } from "utils/utils";

const AutoGrowingTextarea = ({ value, onChange,label, className="", ...rest }) => {
  const textareaRef = useRef(null);

  const handleInput = (e) => {
    const textarea = textareaRef.current;

    textarea.style.height = "auto";
    textarea.style.height = `${textarea.scrollHeight}px`;

    onChange(e);
  };

  return (
    <>
    {label && <label className={rest.labelClassName}>{label}</label>}
    <textarea
      ref={textareaRef}
      className={combineClasses(styles.newPost_textarea, className)}
      value={value}
      onChange={handleInput}
      {...rest}
    //   placeholder="Share your creatives"
    />
    </>
  );
};

export default AutoGrowingTextarea;
